import { Component, HostBinding } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-radio',
  styleUrls: ['form-radio.component.scss'],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section w-100"
        [class.mat-error]="formControl.errors && formControl.touched"
      >
        <span tabindex="0" [innerHTML]="props.label"></span>
        @if (props.required) {
          <sup>*</sup>
        }
        @if (props.help) {
          <span
            matTooltip="{{ props.help }}"
            aria-label="help"
            tabindex="0"
            [matTooltipPosition]="'above'"
            [matTooltipClass]="'rb-tooltip'"
          >
            <mat-icon class="col-1 help-icon"> help </mat-icon>
          </span>
        }
      </label>
    }
    <mat-radio-group
      class="radio-group radio-group-explanation col-12"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
    >
      @for (opt of to?.options; track $index) {
        <mat-radio-button
          id="{{ field.key }}-{{ $index }}"
          class="radio-button"
          [value]="opt.value"
          >{{ opt.label }}</mat-radio-button
        >
      }
      @if (field.props.imageName) {
        <img
          alt="{{ field.props.imageName }}"
          [src]="'./assets/' + field.props.imageName"
        />
      }
      @if (formControl.hasError('required') && formControl.touched) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired') && formControl.touched) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-radio-group>
  `,
  imports: [
    FormlyModule,
    MatIconModule,
    MatRadioModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyRadioComponent extends FieldType {
  @HostBinding('class') classes = 'bottom-margin';
}
